module.exports = __webpack_public_path__ + "img/leftTou.99e7ab50.svg";